<template>
	<information-card
		sub-title="INSTRUCTIVO"
	>
		<div slot="title" class="tw-py-6">
			<h3 class="tw-text-center text-primary uppercase">Presupuesto de Nómina</h3>
		</div>
		<div slot="content">
			<div v-html="description"></div>
		</div>
		<div slot="footer" class="tw-text-center">
			<v-btn class="custom-button black" color="primary" @click="goBack">Atrás</v-btn>
			<v-btn :disabled="!enableSave" class="custom-button" color="primary" @click="$emit('saveClick')">Guardar</v-btn>
		</div>
	</information-card>
</template>

<script>
import InformationCard from '@/modules/shared/components/content/InformationCard';


export default {
	name: 'payroll-proposal-description',
	components: { InformationCard },
	props: ['description', 'enableSave'],
	methods: {
		goBack() {
			this.goTo('job-supply-valuation-model-degrees');
		},
	},
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/payroll-proposal/payroll-proposal-description.vue